namespace TabAurous.JobWork {
    export interface JobWorkReturnRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        PartyId?: number;
        LedgerName?: string;
        PartyCode?: string;
        GstVat?: string;
        TaxRegType?: string;
        Address1?: string;
        Country?: string;
        State?: string;
        City?: string;
        TermsId?: number;
        OrderType?: number;
        CurrencyId?: number;
        ExchRate?: number;
        RoundOff?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        BillAddId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: JobWorkReturnItemsRow[];
        TaxDetails?: JobWorkReturnTaxRow[];
        DepartmentId?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
    }

    export namespace JobWorkReturnRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'JobWork.JobWorkReturn';
        export const deletePermission = 'JobWork:JobWorkReturn:Delete';
        export const insertPermission = 'JobWork:JobWorkReturn:Add';
        export const readPermission = '*';
        export const updatePermission = 'JobWork:JobWorkReturn:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            GstVat = "GstVat",
            TaxRegType = "TaxRegType",
            Address1 = "Address1",
            Country = "Country",
            State = "State",
            City = "City",
            TermsId = "TermsId",
            OrderType = "OrderType",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            RoundOff = "RoundOff",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            BillAddId = "BillAddId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            TaxDetails = "TaxDetails",
            DepartmentId = "DepartmentId",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight"
        }
    }
}
